import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { hideModal } from "../../../redux/actions/modals";
import { State } from "../../../redux/reducers/root";
import { useQuery } from "../../../utils/hooks";
import AskCreateTimeslots from "./ask-create-timeslot";
import BookingInfo from "./booking-info";
import CommentInfo from "./comment-info";
import {
  ASK_CREATE_TIMESLOT_MODAL,
  COMMENT_INFO_MODAL,
  BOOKING_INFO_MODAL,
  SELECT_DOCTOR_MODAL,
  TIMESLOT_DETIAL_MODAL,
  EDIT_SCHEDULE_MODAL,
  DROPDOWN_MODAL,
  PAYMENT_MODAL,
  BIDDING_PRIZE_MODAL,
  REGISTER_UER_MODAL,
  FOLLOWUP_SCHEDULE_MODAL,
  COMMENT_RESPONSE_MODAL,
  GALLERY_IMAGE_MODAL,
  PROFILE_PICTURE_MODAL,
  ALGORITHM_MODAL,
  CHANGE_PRICE_MODAL,
  UPLOAD_PROFILE_IMAGE,
} from "./constants";
import DropdownModal from "./dropdown";
import EditScheduleModal from "./edit-schedule";
import PaymentModal from "./payment-modal";
import SelectDoctorModal from "./select-doctor-modal";
import TimeslotDetailModal from "./timeslot-detail";
import BiddingPrizeModal from "./bidding-prize";
import RegisterUserModal from "./register-user-modal";
import FollowupSchedule from "./followup-schedule";
import CommentResponseModal from "./comment-response";
import ProfilePictureModal from "./profile-picture-modal";
import GalleryImageModal from "./gallery-image-modal";
import Algorithm from "./algorithm";
import ChangePriceModal from "./edit-duration-in-schedule";
import EditProfileImage from "./editProfileImage";

interface Props {}

const Modals: React.FC<Props> = () => {
  const modals = useSelector((state: State) => state.modals);

  const { visible, modal } = modals;
  const dispatch = useDispatch();

  const [visibility, setVisibility] = useState(false);

  const query = useQuery();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const body = document.body;
    if (visible) {
      body.classList.add("modal-open");
      query.set("modal", modal!);
      setVisibility(true);
      const path = `${location.pathname}?${query.toString()}`;
      history.push(path);
    } else {
      body.classList.remove("modal-open");
      query.delete("modal");
      setTimeout(() => {
        setVisibility(false);
        history.push(`${location.pathname}?${query.toString()}`);
      }, 300);
    }
  }, [visible]);

  const hide = () => {
    dispatch(hideModal());
  };

  return (
    <>
      <div
        className={`fixed top-0 bottom-0 left-0 right-0 z-50 flex justify-center ${visibility ? "block" : "hidden"}`}
      >
        <div
          onClick={hide}
          className={`absolute top-0 bottom-0 left-0 animate-fade-in-60 right-0 transform transition-all duration-300  flex items-end bg-pkc-silver  ${
            visible ? " opacity-60" : "opacity-0"
          }`}
        />
        <div
          className={`max-h-full absolute w-full max-w-xl transform transition-all duration-300 animate-fade-up bottom-0 p-4 rounded-b-none bg-pkc-white rounded-t-box ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-28"
          }`}
        >
          {modal === SELECT_DOCTOR_MODAL && <SelectDoctorModal />}
          {modal === COMMENT_INFO_MODAL && <CommentInfo />}
          {modal === BOOKING_INFO_MODAL && <BookingInfo />}
          {modal === ASK_CREATE_TIMESLOT_MODAL && <AskCreateTimeslots />}
          {modal === CHANGE_PRICE_MODAL && <ChangePriceModal />}
          {modal === TIMESLOT_DETIAL_MODAL && <TimeslotDetailModal />}
          {modal === EDIT_SCHEDULE_MODAL && <EditScheduleModal />}
          {modal == FOLLOWUP_SCHEDULE_MODAL && <FollowupSchedule />}
          {modal === DROPDOWN_MODAL && <DropdownModal />}
          {modal === PAYMENT_MODAL && <PaymentModal />}
          {modal === BIDDING_PRIZE_MODAL && <BiddingPrizeModal />}
          {modal === REGISTER_UER_MODAL && <RegisterUserModal />}
          {modal === COMMENT_RESPONSE_MODAL && <CommentResponseModal />}
          {modal === PROFILE_PICTURE_MODAL && <ProfilePictureModal />}
          {modal === GALLERY_IMAGE_MODAL && <GalleryImageModal />}
          {modal === ALGORITHM_MODAL && <Algorithm />}
          {modal === UPLOAD_PROFILE_IMAGE && <EditProfileImage />}
        </div>
      </div>
    </>
  );
};

export default Modals;
